/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_zS_122_83(e) {
  let t = (0, ReactCompiler.c)(3),
    { label: n, children: r } = e,
    i;
  return (
    t[0] !== r || t[1] !== n
      ? ((i = (
          <label
            className={`flex flex-col gap-1 text-xs text-(--text)`}
            children={[n, r]}
          />
        )),
        (t[0] = r),
        (t[1] = n),
        (t[2] = i))
      : (i = t[2]),
    i
  );
}
